import Accordion from 'react-bootstrap/Accordion';
import './Register.css'
import horzintal3 from '../Images/horzintal3.png'
import mobile from '../Images/mobile.png'
import password from '../Images/password.png'
import instagram from '../Images/instagram3.png'
import telegram from '../Images/telegram3.png'
import barcode from '../Images/barcode.png'
import person from '../Images/person.png'

import whatsapp from '../Images/whatsapp3.png'
import Eitaa from '../Images/Eitaa3.png'
import bale from '../Images/bale3.png'

import gift from '../Images/gift.png'
import horzintal2 from '../Images/horzintal2.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";
import QrCodeGet from './QrCodeGet'
export default function Register() {
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { code } = useParams();
    const formRef = useRef(null);
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            name: "", username: "", code: "", showData: "Show", instagram: "",
             telegram: "", password: "", comment: "", price: null,
             eita:"",baleh:"",whatsapp:""
        });
    useEffect(() => {
        if (code)
            setForm(p => ({ ...p, code: code }));
    }, [code]);
    useEffect(() => {
        const id=searchParams.get('id');
         if (id) 
              setForm(p => ({ ...p, code: id }));
        //const jwt = http.getLocalJwt();
        //if (jwt && jwt != "") {
        //    navigate('/main');
        //}
    }, []);


    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await Services.Register(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                http.setLocalJwt(data.payload.accessToken);
                navigate('/main');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }
    const [showQrCodeGet, setShowQrCodeGet] = useState(false)
    const [isBusy, setIsBusy] = useState(false)
    const choiceBarcode = (e) => {
        setShowQrCodeGet(false);
    }
    return (
        <>
            {showQrCodeGet &&
                <QrCodeGet
                    isBusy={isBusy}
                    handleClose={e => { setShowQrCodeGet(false) }}
                    show={showQrCodeGet}
                    onChoice={choiceBarcode} />
            }
            <div className="row mb-2">
                <div className="col d-flex justify-content-center">
                    <span className="text-white"> ثبت اطلاعات برچسب</span>
                </div>
            </div>

            <form ref={formRef} className=" needs-validation">
                <div className="row ">
                    <div className="col p-3 ">
                        <div id="boxBarcode" className="d-flex p-2 align-items-center">
                            <div>
                                <img src={barcode} className='me-2' onClick={e => {
                                    e.preventDefault();
                                    setShowQrCodeGet(true);
                                }} />
                            </div>
                            <div className="text-white mx-1  text-nowrap">شماره برچسب :</div>
                            <input
                                id="inputBarCode"
                                asp-for="code"
                                type="text"
                                name="code"
                                value={form.code}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control"
                                placeholder="وارد کنید"
                                required
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
                <div className='row '>
                    <div className='col'>
                        <img src={horzintal2} />
                    </div>
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={person}
                            className=" " />
                    </div>
                    <input
                        asp-for="name"
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="نام و نام خانوادگی"
                        required
                        autoComplete="off" />
                    <span
                        asp-validation-for="name"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={mobile}
                            className=" " />
                    </div>
                    <input
                        asp-for="username"
                        type="number"
                        name="username"
                        value={form.username}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="شماره موبایل"
                        required
                        autoComplete="off" />
                    <span
                        asp-validation-for="username"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={password}
                            className=" " />
                    </div>
                    <input
                        asp-for="password"
                        type="text"
                        name="password"
                        value={form.password}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="کلمه عبور"
                        required
                        autoComplete="off" />
                    <span
                        asp-validation-for="password"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={gift}
                            className=" " />
                    </div>
                    <input
                        asp-for="price"
                        type="text"
                        name="price"
                        value={form.price}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="مبلغ مژدگانی (اختیاری)"
                        autoComplete="off" />
                    <span
                        asp-validation-for="price"
                        className="text-danger" />
                </div>
                <Accordion className='accordingCustom ' >
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><img src={horzintal3} />اطلاعات بیشتر ( اختیاری ) <img src={horzintal3} /></Accordion.Header>
                        <Accordion.Body>
                            <div className="input-group mb-3">
                                <div className="input-group-text" >
                                    <img
                                        src={instagram}
                                        className=" " />
                                </div>
                                <input
                                    asp-for="instagram"
                                    type="text"
                                    name="instagram"
                                    value={form.instagram}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="آی دی اینستاگرام"
                                    autoComplete="off" />
                                <span
                                    asp-validation-for="instagram"
                                    className="text-danger" />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-text" >
                                    <img
                                        src={telegram}
                                        className=" " />
                                </div>
                                <input
                                    asp-for="telegram"
                                    type="text"
                                    name="telegram"
                                    value={form.telegram}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="آی دی تلگرام"
                                    autoComplete="off" />
                                <span
                                    asp-validation-for="telegram"
                                    className="text-danger" />
                            </div>
                             <div className="input-group mb-3">
                                <div className="input-group-text" >
                                    <img
                                        src={whatsapp}
                                        className=" " />
                                </div>
                                <input
                                    asp-for="whatsapp"
                                    type="text"
                                    name="whatsapp"
                                    value={form.whatsapp}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="واتس آپ"
                                    autoComplete="off" />
                                <span
                                    asp-validation-for="whatsapp"
                                    className="text-danger" />
                            </div>
                             <div className="input-group mb-3">
                                <div className="input-group-text" >
                                    <img
                                        src={bale}
                                        className=" " />
                                </div>
                                <input
                                    asp-for="baleh"
                                    type="text"
                                    name="baleh"
                                    value={form.baleh}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="بله"
                                    autoComplete="off" />
                                <span
                                    asp-validation-for="baleh"
                                    className="text-danger" />
                            </div>
                             <div className="input-group mb-3">
                                <div className="input-group-text" >
                                    <img
                                        src={Eitaa}
                                        className=" " />
                                </div>
                                <input
                                    asp-for="eita"
                                    type="text"
                                    name="eita"
                                    value={form.eita}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="ایتا"
                                    autoComplete="off" />
                                <span
                                    asp-validation-for="eita"
                                    className="text-danger" />
                            </div>
                            <div className="input-group mb-3">
                                <textarea
                                    asp-for="comment"
                                    type="text"
                                    name="comment"
                                    value={form.comment}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="توضیحات (اختیاری)"
                                    rows={3}
                                    autoComplete="off" />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="form-check mt-4 mb-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value={form.showData}
                        name="Password"
                        onChange={(e) => {
                            setForm({ ...form, showData: e.target.checked ? 'Show' : 'Hide' });
                        }}
                        checked={form.showData == "Show"}
                    />
                    <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                        شماره تماس نمایش داده شود.
                    </label>
                </div>
                <div className='row'>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn1 py-3"
                            onClick={handlePosting}
                            disabled={isPosting}>
                            ثبت اطلاعات
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </button>
                    </div>
                </div>
            </form>
            <div className="row mt-4">
                <div className="col d-flex justify-content-center">
                    <span className="text-white"> قبلا ثبت نام کردید؟</span>
                    <Link
                        className="textColor1 text-decoration-none ms-1"
                        to="/login"> ورود</Link>
                </div>
            </div>
        </>

    );

}
